<template>
    <form v-bind="$attrs" @submit.prevent="handle">
        <slot />
    </form>
</template>

<script>
    export default {
        name: 'app-form',
        methods: {
            handle() {
                this.$emit('submit');
            }
        }
    }
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Form.vue